/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AuthRequestBody {
  /** @example Operator1 */
  login: string;

  /** @example qwe */
  password: string;
}

export interface AuthResponse {
  token: { access: string; refresh: string };
  userData: Author;
}

export interface ChatMessagesResponse {
  /** @example dDKVZIABjxExQYFXkv6H */
  chatId: string;
  messages: MessageNew[];
  authors: Author[];
}

export interface OperatorsResponse {
  operators: {
    operatorId: string;
    firstName: string;
    lastName: string;
    role: "operator" | "supervisor";
  }[];
}

export type OperatorChatsResponse = OperatorChat[];

export interface OperatorChat {
  chatId: string;
  channel: string;
  lastMessage: { messages: MessageNew[]; authors: Author[] };
  datetime: string;
  conversationTime: string;
  user: Author;
}

export interface OperatorStatusesResponse {
  status?: ("not_active" | "active" | "invisible" | "break" | "offline")[];
}

export interface OperatorStatusesUpdatedResponse {
  status?: "not_active" | "active" | "invisible" | "break" | "offline";
}

export type UserInfoResponse = {
  id: number;
  groupName: string;
  fields: { name: string; value: string; variable: string }[];
}[];

export interface AnalyticsWaitingRoomResponse {
  /** @example high */
  priority: "high" | "middle" | "low";
  channelName: string;
  userId: string;
  firstName: string;
  lastName: string;
  chatId: string;
  conversationAt: string;
}

export interface MessageCreateRequest {
  content: { text: string };
}

export interface MessageCreateResponse {
  chatId: string;
  messages: Messages;
  authors: Authors;
}

export interface AppealsTopicsResponse {
  /** @example 2 */
  parentId: number;
  topics: { id: number; name: string }[];
}

export interface AppealsCreateRequest {
  /** @example 1dfsd9f8-dsfao7ydfv */
  userId: string;

  /** @example asdiuhf-sadv98fv */
  operatorId: string;
  topics: Record<string, string>[];
}

export interface AppealsCreateResponse {
  appeals: {
    id: number;
    userId: string;
    operatorId: string;
    topics?: Record<string, string>;
    period: string;
  }[];
}

export interface MessageTypeText {
  /** @example dTKVZIABjxExQYFXkv7v */
  messageId: string;

  /** @example 2022-04-26 06:36:05.720 */
  datetime: string;

  /** @example user */
  author: string;

  /** @example text */
  type: string;
  content: { text: string };
}

export interface MessageTypeButton {
  /** @example dTKVZIABjxExQYFXkv7v */
  messageId: string;

  /** @example 2022-04-26 06:36:05.720 */
  datetime: string;

  /** @example user */
  author: string;

  /** @example button */
  type: string;
  content: { title: string; callback: { step: string; domain: string } };
}

export interface MessageTypeFile {
  /** @example dTKVZIABjxExQYFXkv7v */
  messageId: string;

  /** @example 2022-04-26 06:36:05.720 */
  datetime: string;

  /** @example user */
  author: string;

  /** @example file */
  type: string;
  content: {
    file: {
      id: string;
      name: string;
      type: string;
      status: "check_for_viruses" | "clean" | "reject" | "done";
    };
  };
}

export interface Message {
  /** @example dTKVZIABjxExQYFXkv7v */
  messageId: string;

  /** @example 2022-05-05 07:41:06.358294 */
  datetime: string;
  author: "bot" | "user" | "operator";
  type: "text" | "command" | "button" | "checkbox" | "file";
  content:
    | MessageContentText
    | MessageContentCommand
    | MessageContentButton
    | MessageContentCheckbox
    | MessageContentFile;
}

export interface MessageContentText {
  /** @example привет */
  text: string;
}

export interface MessageContentCommand {
  /** @example /operator */
  text: string;
}

export interface MessageContentButton {
  /** @example 7 */
  butId: number;

  /** @example Мне понравилось! */
  title: string;
  callback: { step: string; domain: string };
  [key: string]: any;
}

export interface MessageContentButtons {
  buttons: MessageContentButton[];

  /** @example привет */
  text: string;
}

export type MessageContentCheckbox =
  | MessageContentCheckboxBot
  | MessageContentCheckboxUser;

export interface MessageContentCheckboxBot {
  /** @example За какой валютой следить ежедневно? */
  text?: string;
  checkboxTemplate: {
    title: string;
    states: { true: string; false: string; default: string };
    checkboxes?: { value: string }[][];
    controls?: {
      title: string;
      type: string;
      step?: string;
      domain?: string;
    }[][];
  };
}

export interface MessageContentCheckboxUser {
  title: string;
  callback: {
    step: string;
    domain?: string;
    checkboxes: { true: string[]; false: string[] };
  };
}

export interface MessageContentFile {
  /** @example посмотри файл */
  text?: string;
  file: {
    id: string;
    name: string;
    type: string;
    status: "check_for_viruses" | "clean" | "reject" | "done";
  };
}

export interface WaitingRoomChangePriority {
  /** @example OtzOsoABkdJlmQSkntFY */
  chatId: string;
  priority?: { old: "high" | "middle" | "low"; new: "high" | "middle" | "low" };
}

export interface MonitoringInfoCounts {
  chats?: {
    inWaitingRooms?: number;
    inHandle?: number;
    mostOldestWaiting?: string;
  };
}

export interface ChatInHandle {
  /**
   * ID чата с данным пользователем
   * @example dIRf3IABGu2JNTS2lEZi
   */
  chatId: string;

  /**
   * время переключения чата на оператора
   * @example 2022-05-19 12:51:34.885
   */
  datetime: string;
  user: {
    id: string;
    firstName: string;
    lastName: string;
    channelName: "Telegram" | "Vkontakte" | "WEB";
  };
  operator: { id: string; firstName: string; lastName: string };
}

export interface TextMessageEntity {
  messageId?: string;
  datetime?: string;
  authorId?: string;
  type?: string;
  content?: { text?: string };
}

export interface ButtonMessageEntity {
  messageId?: string;
  datetime?: string;
  authorId?: string;
  type?: string;
  content?: {
    text?: string;
    buttons?: {
      title?: string;
      callback?: { step?: string; domain?: string; notRequiredValue?: string };
    }[][];
  };
}

export interface TransferChatRequestBody {
  chatId: string;
  targetOperatorId?: string;
  comment?: string;
}

export interface TransferChatResponse {
  operatorId: string;
  firstName: string;
  lastName: string;
  role: string;
}

export interface OperatorChatTransferRequestBody {
  /** Идентификатор чата */
  chatId: string;

  /** Идентификатор оператора получателя чата */
  targetOperatorId: string;

  /** Комментарий оператора */
  comment?: string;
}

export interface OperatorStatusUpdateRequestBody {
  nextStatus?: string;
}

export type UserInfoUpdateRequestBody = {
  name: string;
  value: string;
  variable: string;
}[];

export interface ChatChangePriorityRequestBody {
  /** @example OtzOsoABkdJlmQSkntFY */
  chatId: string;

  /** @example high */
  priority: "high" | "middle" | "low";
}

/**
 * Значение может быть любого типа
 */
export type AnyValue = any;

export interface Event {
  event:
    | "new_chat_init"
    | "income_message"
    | "update_message"
    | "chat_takeaway"
    | "check_connection";
  data:
    | EventNewChatInitData
    | EventIncomeMessageData
    | EventUpdateMessageData
    | EventChatTakeawayData
    | EventCheckConnectionData;
}

export type EventNewChatInitData = OperatorChat;

export interface EventIncomeMessageData {
  chatId: string;
  messages: MessageNew[];
  authors: Author[];
}

export interface EventUpdateMessageData {
  chatId: string;
  messages: MessageNew[];
  authors: Author[];
}

export interface EventChatTakeawayData {
  chatId: string;
}

/**
 * Пустая строка
 * @example
 */
export type EventCheckConnectionData = string;

export interface MessageNew {
  messageId: string;
  authorId: string;
  datetime: string;
  type: string;
  content:
    | MessageContentText
    | MessageContentCommand
    | MessageContentButton
    | MessageContentButtons
    | MessageContentCheckbox
    | MessageContentFile;
}

export type Messages = MessageNew[];

export interface Author {
  userId: string;
  passport: { firstName: string; lastName: string; middleName: string };
  channel: Record<string, any>;
  facilities: { role: string };
  extras: {
    status?: "not_active" | "active" | "invisible" | "break" | "offline";
    [key: string]: any;
  };
}

export type Authors = Author[];

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис automated-working-place
 * @version 1.0.1
 * @baseUrl /supporter/api
 *
 * АРМ оператора и диалоги с пользователем
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  v1 = {
    /**
     * @description Возвращает информацию об авторизованном пользователе.
     *
     * @tags Auth
     * @name AuthList
     * @summary Возвращает информацию об авторизованном пользователе.
     * @request GET:/v1/auth
     */
    authList: (params: RequestParams = {}) =>
      this.request<Author, any>({
        path: `/v1/auth`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthCreate
     * @request POST:/v1/auth
     */
    authCreate: (data?: AuthRequestBody, params: RequestParams = {}) =>
      this.request<AuthResponse, void>({
        path: `/v1/auth`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chats
     * @name ChatsDelete
     * @request DELETE:/v1/chats/{chatId}
     */
    chatsDelete: (chatId: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/v1/chats/${chatId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Возвращает список сообщений из чата `chatId`.<br>Если указан параметр `messageId`, выгрузка происходит относительно этого сообщения.<br>Направление выгрузки можно указать с помощью параметра `route`.<br>Через параметр `limit` можно указать количество выгружаемых сообщений.<br>Поиск по сообщениям осуществляется через параметр `query`, при этом параметры `messageId`, `route` и `limit` не влияют на выдачу.
     *
     * @tags Chats
     * @name ChatsMessagesDetail
     * @summary Возвращает список сообщений
     * @request GET:/v1/chats/{chatId}/messages
     * @secure
     */
    chatsMessagesDetail: (
      chatId: string,
      query?: {
        messageId?: string;
        route?: "before" | "after" | "both";
        limit?: number;
        query?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ChatMessagesResponse, void>({
        path: `/v1/chats/${chatId}/messages`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Отправляет сообщение в чат `chatId`
     *
     * @tags Chats
     * @name ChatsMessagesCreate
     * @summary Отправляет сообщение
     * @request POST:/v1/chats/{chatId}/messages
     * @secure
     */
    chatsMessagesCreate: (
      chatId: string,
      data: MessageCreateRequest,
      params: RequestParams = {}
    ) =>
      this.request<MessageCreateResponse, EventCheckConnectionData>({
        path: `/v1/chats/${chatId}/messages`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operators
     * @name OperatorsList
     * @summary Запросить список операторов
     * @request GET:/v1/operators
     * @secure
     */
    operatorsList: (
      query?: { connected?: "true" },
      params: RequestParams = {}
    ) =>
      this.request<OperatorsResponse, any>({
        path: `/v1/operators`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operators
     * @name OperatorsChatsDetail
     * @request GET:/v1/operators/{operatorId}/chats
     * @secure
     */
    operatorsChatsDetail: (operatorId: string, params: RequestParams = {}) =>
      this.request<OperatorChatsResponse, any>({
        path: `/v1/operators/${operatorId}/chats`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Переключить чат `chatId` c оператора `operatorId` на оператора `targetOperatorId`.
     *
     * @tags Operators
     * @name OperatorsChatsPartialUpdate
     * @summary Переключить чат на другого оператора
     * @request PATCH:/v1/operators/{operatorId}/chats
     * @secure
     */
    operatorsChatsPartialUpdate: (
      operatorId: string,
      data: OperatorChatTransferRequestBody,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/v1/operators/${operatorId}/chats`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Данный эндпоинт не закрывается, пока клиент не разорвет подключение. В рамках постоянно открытого подключения эндпоинт возвращает эвенты (события) которые происходят на BackEnd. Примеры этих событий указаны в ответе с кодом 200.
     *
     * @tags Operators, SSE-канал
     * @name OperatorsUpdatesDetail
     * @summary Подключение оператора к SSE-каналу
     * @request GET:/v1/operators/{operatorId}/updates
     */
    operatorsUpdatesDetail: (
      operatorId: string,
      query: { access_token: string },
      params: RequestParams = {}
    ) =>
      this.request<Event, any>({
        path: `/v1/operators/${operatorId}/updates`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operators
     * @name OperatorsStatusesDetail
     * @request GET:/v1/operators/{operatorId}/statuses
     */
    operatorsStatusesDetail: (operatorId: string, params: RequestParams = {}) =>
      this.request<OperatorStatusesResponse, any>({
        path: `/v1/operators/${operatorId}/statuses`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operators
     * @name OperatorsStatusesPartialUpdate
     * @request PATCH:/v1/operators/{operatorId}/statuses
     */
    operatorsStatusesPartialUpdate: (
      operatorId: string,
      data: OperatorStatusUpdateRequestBody,
      params: RequestParams = {}
    ) =>
      this.request<OperatorStatusesUpdatedResponse, any>({
        path: `/v1/operators/${operatorId}/statuses`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operators
     * @name OperatorsChatsPartialUpdate2
     * @summary Переключить чат на другого оператора
     * @request PATCH:/v1/operators/chats
     * @originalName operatorsChatsPartialUpdate
     * @duplicate
     */
    operatorsChatsPartialUpdate2: (
      data: TransferChatRequestBody,
      params: RequestParams = {}
    ) =>
      this.request<TransferChatResponse, EventCheckConnectionData | void>({
        path: `/v1/operators/chats`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Закрываются соединения оператора, устанавливается статус offline
     *
     * @tags Operators
     * @name OperatorsLogoutDetail
     * @summary Запросить отключение оператора
     * @request GET:/v1/operators/{operatorId}/logout
     */
    operatorsLogoutDetail: (operatorId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/v1/operators/${operatorId}/logout`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Возвращает информацию о пользователе `userId`
     *
     * @tags Users
     * @name UsersDetail
     * @summary Возвращает информацию о пользователе
     * @request GET:/v1/users/{userId}
     */
    usersDetail: (userId: string, params: RequestParams = {}) =>
      this.request<UserInfoResponse, any>({
        path: `/v1/users/${userId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Выполняет обновление информации о пользователе `userId`
     *
     * @tags Users
     * @name UsersPartialUpdate
     * @summary Выполняет обновление информации о пользователе
     * @request PATCH:/v1/users/{userId}
     * @secure
     */
    usersPartialUpdate: (
      userId: string,
      data: UserInfoUpdateRequestBody,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/v1/users/${userId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags monitoring
     * @name MonitoringDialogsInWaitingroomsList
     * @summary Возвращает диалоги из зала ожидания
     * @request GET:/v1/monitoring/dialogs/in-waitingrooms
     * @secure
     */
    monitoringDialogsInWaitingroomsList: (params: RequestParams = {}) =>
      this.request<AnalyticsWaitingRoomResponse[], any>({
        path: `/v1/monitoring/dialogs/in-waitingrooms`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Получает информацию о чатах, которые на данный момент обрабатываются операторами
     *
     * @tags monitoring
     * @name MonitoringDialogsInHandleList
     * @summary Возвращает диалоги в обработке у операторов
     * @request GET:/v1/monitoring/dialogs/in-handle
     * @secure
     */
    monitoringDialogsInHandleList: (params: RequestParams = {}) =>
      this.request<ChatInHandle[], any>({
        path: `/v1/monitoring/dialogs/in-handle`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags monitoring
     * @name MonitoringDialogsCountsList
     * @summary Возвращает информацию о количестве диалогов и времени последнего диалога
     * @request GET:/v1/monitoring/dialogs/counts
     * @secure
     */
    monitoringDialogsCountsList: (params: RequestParams = {}) =>
      this.request<MonitoringInfoCounts, any>({
        path: `/v1/monitoring/dialogs/counts`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Appeals
     * @name AppealsCreate
     * @request POST:/v1/appeals
     * @secure
     */
    appealsCreate: (data: AppealsCreateRequest, params: RequestParams = {}) =>
      this.request<AppealsCreateResponse, void>({
        path: `/v1/appeals`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Appeals
     * @name AppealsTopicsList
     * @request GET:/v1/appeals/topics
     */
    appealsTopicsList: (
      query?: { parent?: number },
      params: RequestParams = {}
    ) =>
      this.request<AppealsTopicsResponse, void>({
        path: `/v1/appeals/topics`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags waiting-rooms
     * @name WaitingRoomsPartialUpdate
     * @request PATCH:/v1/waiting-rooms
     * @secure
     */
    waitingRoomsPartialUpdate: (
      data: ChatChangePriorityRequestBody,
      params: RequestParams = {}
    ) =>
      this.request<WaitingRoomChangePriority, any>({
        path: `/v1/waiting-rooms`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
